exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-3d3a0d4f] {\n  font-weight: 600;\n  color: black;\n}\nth[data-v-3d3a0d4f] {\n  font-size: 13px;\n  font-family: Roboto;\n}\ntd[data-v-3d3a0d4f] {\n  font-size: 12px;\n  font-family: Roboto;\n}\n.mx-datepicker[data-v-3d3a0d4f] {\n  width: 251px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d3a0d4f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/reports/grcLogReport/grcLogReport.component.scss
// module id = 1875
// module chunks = 0